module.exports = __webpack_public_path__ + "static/media/Plateau_H_3.aff341e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_H_3.svg
// module id = 785
// module chunks = 0